

export function addNotification(text) {
  const list = JSON.parse(localStorage.getItem("adminNotifications") || "[]");

  const notif = {
    id: Date.now(),
    text,
    date: new Date().toLocaleString(),
    read: false,
  };

  list.unshift(notif);
  localStorage.setItem("adminNotifications", JSON.stringify(list));
}

export function getNotifications() {
  return JSON.parse(localStorage.getItem("adminNotifications") || "[]");
}

export function markAllAsRead() {
  const list = getNotifications().map(n => ({ ...n, read: true }));
  localStorage.setItem("adminNotifications", JSON.stringify(list));
}

export function clearNotifications() {
  localStorage.setItem("adminNotifications", "[]");
}

export function unreadCount() {
  return getNotifications().filter(n => !n.read).length;
}
